import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';
import { Shield, Mail, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import { API_URL } from '../config';
import '../styles/Auth.css';


const ResendVerification = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatus('loading');
    
    try {
      await axios.post(`${API_URL}/api/auth/resend-verification`, null, {
        params: { email }
      });
      setStatus('success');
    } catch (err) {
      console.error('Resend verification failed:', err);
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <>
        <Header />
        <div className="auth-page resend-verification-page">
          <div className="auth-container">
            <div className="auth-logo-container">
              <Shield size={40} />
              <span>All Secured</span>
            </div>
            
            <div className="auth-status-container success">
              <CheckCircle size={48} className="success-icon" />
              <h2>Check Your Email</h2>
              <p>
                If an unverified account exists with <strong>{email}</strong>, you'll receive a verification link shortly.
              </p>
              <p className="auth-note">
                Don't forget to check your spam folder!
              </p>
              <div className="auth-actions">
                <Link to="/login" className="auth-secondary-btn">
                  Go to Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="auth-page resend-verification-page">
        <div className="auth-container">
          <div className="auth-logo-container">
            <Shield size={40} />
            <span>All Secured</span>
          </div>
          
          <div className="auth-form-container">
            <div className="auth-header">
              <Mail size={32} className="auth-icon" />
              <h2>Resend Verification Email</h2>
              <p>Enter your email and we'll send you a new verification link.</p>
            </div>
            
            <form onSubmit={handleSubmit} className="auth-form">
              {error && (
                <div className="auth-error">
                  <AlertCircle size={16} />
                  <span>{error}</span>
                </div>
              )}
              
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  data-testid="email-input"
                />
              </div>
              
              <button 
                type="submit" 
                className="auth-submit-btn"
                disabled={status === 'loading'}
                data-testid="resend-verification-btn"
              >
                {status === 'loading' ? (
                  <>
                    <Loader2 className="btn-spinner" size={18} />
                    Sending...
                  </>
                ) : (
                  'Resend Verification Email'
                )}
              </button>
            </form>
            
            <div className="auth-footer">
              <p>
                Already verified?{' '}
                <Link to="/login" className="auth-link">
                  Sign in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResendVerification;
